import { CSS, Link, Typography } from '@project44/manifest-ds';

interface Props {
  label: string;
  href?: string;
  onClick?: () => void;
  css?: CSS;
}

const Breadcrumb: React.FC<Props> = ({ label, href, onClick, css }) =>
  href || onClick ? (
    <Link
      href={href}
      onClick={onClick}
      css={{ cursor: 'pointer', textDecoration: 'none', ...css }}
    >
      {label}
    </Link>
  ) : (
    <Typography variant="bodyBold" css={{ display: 'inline', ...css }}>
      {label}
    </Typography>
  );

export default Breadcrumb;
